var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 83.3125C63.7798 83.3125 80.625 66.4673 80.625 45.6875C80.625 24.9078 63.7798 8.0625 43 8.0625C22.2203 8.0625 5.375 24.9078 5.375 45.6875C5.375 52.4355 7.15144 58.7686 10.2621 64.2447L5.375 83.3125L25.0337 78.754C30.3725 81.6608 36.4933 83.3125 43 83.3125ZM43 77.5242C60.583 77.5242 74.8367 63.2705 74.8367 45.6875C74.8367 28.1048 60.583 13.851 43 13.851C25.4172 13.851 11.1635 28.1048 11.1635 45.6875C11.1635 52.4764 13.2883 58.7689 16.9093 63.9362L14.0577 74.6297L24.9398 71.9092C30.0715 75.4505 36.2936 77.5242 43 77.5242Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 43C75.25 60.8111 60.8111 75.25 43 75.25C36.2065 75.25 29.9035 73.1494 24.7053 69.5624L13.6818 72.3182L16.5705 61.4857C12.9025 56.2513 10.75 49.877 10.75 43C10.75 25.1888 25.1888 10.75 43 10.75C60.8111 10.75 75.25 25.1888 75.25 43Z",
    fill: "url(#paint0_linear_2503_6778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 80.625C63.7798 80.625 80.625 63.7798 80.625 43C80.625 22.2203 63.7798 5.375 43 5.375C22.2203 5.375 5.375 22.2203 5.375 43C5.375 49.748 7.15144 56.0811 10.2621 61.5572L5.375 80.625L25.0337 76.0665C30.3725 78.9733 36.4933 80.625 43 80.625ZM43 74.8367C60.583 74.8367 74.8367 60.583 74.8367 43C74.8367 25.4172 60.583 11.1635 43 11.1635C25.4172 11.1635 11.1635 25.4172 11.1635 43C11.1635 49.7889 13.2883 56.0814 16.9093 61.2487L14.0577 71.9422L24.9398 69.2217C30.0715 72.763 36.2936 74.8367 43 74.8367Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 25.532C32.6994 23.7352 31.3268 23.8942 29.9406 23.8942C27.463 23.8942 23.5996 26.862 23.5996 32.3854C23.5996 36.9119 25.5943 41.8669 32.3156 49.2793C38.8021 56.4329 47.3253 60.1333 54.4009 60.0072C61.4766 59.8815 62.9324 53.7924 62.9324 51.7362C62.9324 50.8249 62.3667 50.3701 61.9772 50.2465C59.566 49.0893 55.1187 46.9331 54.1069 46.5281C53.0951 46.1231 52.5667 46.6711 52.2383 46.9691C51.3208 47.8433 49.5019 50.4207 48.8789 51.0003C48.2562 51.58 47.3277 51.2866 46.9412 51.0675C45.5193 50.497 41.664 48.7821 38.5912 45.803C34.7905 42.119 34.5674 40.8513 33.8515 39.7231C33.2788 38.8203 33.6991 38.2667 33.9087 38.0246C34.7276 37.0799 35.8582 35.6211 36.3654 34.8963C36.8722 34.1712 36.4699 33.0707 36.2283 32.3854C35.1896 29.4372 34.3094 26.9693 33.5938 25.532Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2503_6778",
    x1: 71.2187,
    y1: 18.8125,
    x2: 10.75,
    y2: 75.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppBigIcon);
export default __webpack_public_path__ + "static/media/whatsAppBigIcon.e0e4a3528fb7ef992e16e921ed10b5d8.svg";
export { ForwardRef as ReactComponent };